import styled from 'styled-components';
import colors from '../colors';
import { baseTyping } from '../typings';

interface PropsI {
  error?: boolean;
  isDisabled?: boolean;
  icon?: boolean;
  labelText?: boolean;
}

export const InputStates = styled.input<PropsI>`
  ${baseTyping}
  font-size: 16px;
  line-height: 24px;

  background-color: ${colors.lightGrey};
  box-sizing: border-box;
  border-radius: 8px;
  padding: ${(props) => (props.icon ? '0 35px 0 16px' : '0 16px')};
  width: 100%;
  height: 40px;
  text-align: left;
  color: ${colors.black};

  &::placeholder {
    ${baseTyping}
    color: ${colors.grey};
  }
  &:hover {
    border: 1.5px solid ${colors.darkGrey};
  }
  &:focus {
    opacity: 1;
    border: 1px solid ${colors.green};
    color: ${colors.black};
    box-shadow: 0 0 0 1px ${colors.green};
    ::placeholder {
      opacity: 0;
    }
  }

  border: 1px solid ${(props) => (props.error ? colors.red : colors.grey)};

  &:disabled {
    border: 1.5px solid ${colors.grey};
    background-color: ${colors.lightGrey};
    color: ${colors.grey};
    ::placeholder {
      color: ${colors.grey};
    }
  }
`;

export const InputWrapper = styled.div<PropsI>`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;

  & svg {
    position: absolute;
    right: 9px;
    top: 50%;
    transform: ${(props) =>
      props.labelText ? 'translateY(0)' : 'translateY(-50%)'};
    & path {
      fill: ${colors.darkGrey};
    }
  }
`;

export const Label = styled.p<PropsI>`
  ${baseTyping}

  font-size: 14px;
  line-height: 24px;
  margin: 0px 0px 0px 17px;
  color: ${(props) =>
    props.error
      ? colors.red
      : props.isDisabled
      ? colors.grey
      : colors.black} !important;
`;

export const ErrorLabel = styled(Label)<PropsI>`
  position: absolute;
  margin-top: ${(props) => (props.labelText ? '65px' : '50px')};
  font-size: 12px;
  line-height: 16px;
`;
